import { Locale } from '__generated__/EditorJsField_data.graphql';

export const useCurrentLanguage = (): Locale => 'LT';
